
export enum PrefixSuffixActionType {
	Add = 'Add',
	Remove = 'Remove'
}
